
import React, {useEffect, useState} from 'react';
import toast from "react-hot-toast";
import {useDropzone} from 'react-dropzone';
import { FormattedMessage } from "react-intl";

import Box from '@mui/material/Box';

import MyImage from "../../myImage"
import MyLabel from "../../myLabel"
import svg from "../../../assets/imgs/update.svg";


const style ={
    container:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '300px',
        height:'200px',
        border: '1px dashed #adb5bd',
        borderRadius: '10px',
        alignItems: 'center',
        cursor: 'pointer',
    },
    icon: {
        width: '30px',
        height:'30px',
    }
}

const DragDropImage = ({image, setFile}) => {

    const validateFile = (file) => {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        if (validTypes.indexOf(file.type) === -1) {
            return false;
        }
        return true;
    }

    const {getRootProps, getInputProps} = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            acceptedFiles.forEach(async  file => {
               if (validateFile(file)) { 
                setFile(file)
                image.set(URL.createObjectURL(file))
               } else { toast.error(<FormattedMessage id='Supports jpg, png and gif' />)}
            })}});

      return (
      <Box sx={style.container} {...getRootProps({className: 'dropzone'})}>
            <MyImage sx={style.icon} src={svg} alt={'update icon'}  />
            <MyLabel component='p' text='Drop your image here' sx={style.title}  />
          <input {...getInputProps()} />
          
          <MyLabel component='p' text='Supports jpg, png and gif' sx={style.title}  />
        
      </Box>
    );
}

export default DragDropImage;